// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1eMDv","label":"Completed_label__KlAkU"};